export default {"src":"/_next/static/media/Ireland.f1bcf108.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};